import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineAddDocument = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      clipPath="url(#a)"
    >
      <path d="M4.062 9.05v5.775M1.175 11.938H6.95M3.275 5.9V2.225a1.05 1.05 0 0 1 1.05-1.05h6.825l3.675 3.675v8.925a1.05 1.05 0 0 1-1.05 1.05h-6.3" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgStreamlineAddDocument;
